import GetGifById from '@/docs-partials/api/endpoints/get-gif-by-id.mdx';
import * as React from 'react';
export default {
  GetGifById,
  React
};